import React from 'react'
import { Button } from 'reactstrap'

const ClearContext = () => {
  return (
    <>
    <div className="notification-bar">
    <div className="divider"></div>
        <span className="notification-text">User cleared the context</span>
        {/* <button className="back-button">↩</button> */}
        <div className="divider"></div>
    </div>
    </>
  )
}

export default ClearContext